<template lang='pug'>
//- SideEffect-Record-Detail
.custom-scrollbar(:class='$style[`cc-side-effect-userRecordDetail`]')
  div(v-if='preloading' :class='$style[`cc-side-effect-userRecordDetail-preload`]')
    IconLoading(:size='30' :color='`#b1b1b1`')

  div(v-else :class='$style[`cc-side-effect-userRecordDetail-wrap`]')
    div(:class='$style[`cc-side-effect-userRecordDetail-filter`]')
      nav(v-if='rwdType === `desktop`' :class='[$style[`cc-side-effect-userRecordDetail-filter-btn`], $style[`cc-side-effect-userRecordDetail-filter-return`]]')
        router-link(
          role='button'
          tabindex='0'
          aria-label='關閉'
          :to='`/sideeffect/record`'
          :class='$style[`cc-side-effect-userRecordDetail-filter-btn-wrap`]')
          IconDelete(:size='20' :color='`#262626`')
          span(:class='$style[`cc-side-effect-userRecordDetail-filter-btn-text`]') 關閉
      nav(v-else :class='[$style[`cc-side-effect-userRecordDetail-filter-btn`], $style[`cc-side-effect-userRecordDetail-filter-return`]]')
        router-link(
          role='button'
          tabindex='0'
          aria-label='返回'
          :to='`/sideeffect/record`'
          :class='$style[`cc-side-effect-userRecordDetail-filter-btn-wrap`]')
          IconOpenArrow(:size='20' :color='`#262626`')
          span(:class='$style[`cc-side-effect-userRecordDetail-filter-btn-text`]') 返回

      nav(:class='$style[`cc-side-effect-userRecordDetail-filter-btn`]')
        button(
          tabindex='0' aria-label='刪除紀錄'
          :class='$style[`cc-side-effect-userRecordDetail-delete`]' @click='deleteEproRecord(recordId)')
          IconTrash(:size='20' :color='`#262626`')
          span 刪除紀錄


      //- nav(:class='$style[`cc-side-effect-userRecordDetail-filter-btn`]')
      //-   span(:class='$style[`cc-side-effect-userRecordDetail-tips-text`]') {{ '編輯完請點擊更新按鈕' }}
      //-   Switcher(
      //-     :key='nextTick'
      //-     title='選擇編輯模式'
      //-     v-model='isEditMode'
      //-     :activeText='`取消編輯`'
      //-     :closeText='`編輯資料`'
      //-     :sizeType='`large`'
      //-     @sendSwitchStatus='setModeSwitchValue')

    header.font-medium(:class='$style[`cc-side-effect-userRecordDetail-title`]') {{ formConfig.se_date }} 的記錄
      //- button(:class='$style[`cc-side-effect-userRecordDetail-download`]' @click='alert()')
      //-   IconDownload(:size='35' :color='`#262626`')

      //- v-if='subscribeVip === `yes`'
      //- button.btn-extra(
      //-   title='PDF下載'
      //-   tabindex='0' aria-label='PDF下載'
      //-   :class='$style[`cc-side-effect-userRecordDetail-download`]'
      //-   @click='alert()')
      //-   span(:class='$style[`cc-side-effect-userRecordDetail-msg-text`]') PDF
      //-   IconDownload2(:size='30' :color='`#262626`')

    //- div(v-if='ai_report_broadcast && ai_report_summary' :class='$style[`cc-side-effect-userRecordDetail-control`]')
    //-   button.btn-extra(
    //-     title='瀏覽分析報告'
    //-     tabindex='0' aria-label='瀏覽分析報告'
    //-     :class='[$style[`cc-side-effect-userRecordDetail-control-btn`], $style[`cc-side-effect-userRecordDetail-control-advise`]]' @click='handleCheckSideEffectReport') 瀏覽分析報告

    //- 基本狀態
    section(:class='$style[`cc-side-effect-userRecordDetail-sec`]')
      div.font-medium(:class='$style[`cc-side-effect-userRecordDetail-sec-header`]') 基本狀態
      div(:class='$style[`cc-side-effect-userRecordDetail-sec-container`]')
        //- 體重
        div(:class='[$style[`cc-side-effect-userRecordDetail-sec-list`], $style[`half-fill`]]')
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
            span 體重
              span (Kg)
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
            span.font-medium {{ formConfig.se_weight }}


        //- 體溫
        div(:class='[$style[`cc-side-effect-userRecordDetail-sec-list`], $style[`half-fill`]]')
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
            span 有發燒超過38度?
              span (攝氏)
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
            span.font-medium {{ formConfig.se_fever > 38 ? `有發燒 (${formConfig.se_fever })` : `沒發燒` }}


        //- 記錄癌症別
        //- div(:class='$style[`cc-side-effect-userRecordDetail-sec-list`]')
        //-   div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
        //-     span!= '記錄癌症別'
        //-   div(v-if='!isEditMode' :class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
        //-     span.font-medium {{ `${formConfig.se_cancertype}` }}
        //-   div(v-else :class='$style[`cc-side-effect-userRecordDetail-sec-area`]')
        //-     SelectModel(
        //-       v-model='formConfig.se_cancertype'
        //-       title='請選擇記錄癌症別'
        //-       style='width: 150px'
        //-       :class='$style[`cc-select-area`]'
        //-       :placehold='`請選擇`'
        //-       :defaultValue='formConfig.se_cancertype'
        //-       :optionList='CANCER_TYPE'
        //-       :errorValue='formVerify.se_cancertypeError'
        //-       @clearErrorMsg="(value) => {this.formVerify.se_cancertypeError = value}")
        //-     Inputer(
        //-       v-if='formConfig.se_cancertype === `填寫其他`'
        //-       v-model='formConfig.se_cancertypeSpecial'
        //-       title='某某癌'
        //-       style='width: 210px; margin-left: 10px'
        //-       :class='$style[`cc-input-area`]'
        //-       :resetButton='false'
        //-       :placehold='`某某癌`'
        //-       :defaultValue='formConfig.se_cancertypeSpecial'
        //-       :errorValue='formVerify.se_cancertypeSpecialError'
        //-       @clearErrorMsg="(value) => {this.formVerify.se_cancertypeSpecialError = value[0];}")

        //- 生活品質
        div(:class='$style[`cc-side-effect-userRecordDetail-sec-list`]')
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
            span 正在接受的治療?
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
            span.font-medium {{ formConfig.se_now_treatment }}


        //- 生活品質
        div(:class='$style[`cc-side-effect-userRecordDetail-sec-list`]')
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
            span 生活品質
              span (越高越好)
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
            span.font-medium(:class='[$style[`cc-side-effect-userRecordDetail-value`], $style[`value-btn${formConfig.se_qualitylife}`]]') {{ formConfig.se_qualitylife }}


        //- 疼痛指數
        div(:class='$style[`cc-side-effect-userRecordDetail-sec-list`]')
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
            span 疼痛指數
              span (越高越痛)
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
            span.font-medium(:class='[$style[`cc-side-effect-userRecordDetail-value`], $style[`value-btn${formConfig.se_painlevel}`]]') {{ formConfig.se_painlevel }}


        //- 心情狀態
        div(:class='$style[`cc-side-effect-userRecordDetail-sec-list`]')
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
            span 心情狀態
              span (越高越好)
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
            span.font-medium(:class='[$style[`cc-side-effect-userRecordDetail-value`], $style[`value-btn${formConfig.se_emotion}`]]') {{ formConfig.se_emotion }}


    //- 一般記錄
    section(:class='$style[`cc-side-effect-userRecordDetail-sec`]')
      div.font-medium(:class='$style[`cc-side-effect-userRecordDetail-sec-header`]') 放化療副作用
      div(:class='$style[`cc-side-effect-userRecordDetail-sec-container`]')
        //- 食慾減少
        div(:class='[$style[`cc-side-effect-userRecordDetail-sec-list`], $style[`half-fill`]]')
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
            span 食慾減少
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
            span.font-medium {{ formConfig.se_noappetite }}


        //- 胃部不適
        div(:class='[$style[`cc-side-effect-userRecordDetail-sec-list`], $style[`half-fill`]]')
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
            span 胃部不適
              span (痛/逆流/脹)
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
            span.font-medium {{ formConfig.se_upsetstomach }}


        //- 腹瀉程度
        div(:class='[$style[`cc-side-effect-userRecordDetail-sec-list`], $style[`half-fill`]]')
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
            span 腹瀉程度
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
            span.font-medium {{ formConfig.se_diarrhea }}


        //- 便秘程度
        div(:class='[$style[`cc-side-effect-userRecordDetail-sec-list`], $style[`half-fill`]]')
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
            span 便秘程度
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
            span.font-medium {{ formConfig.se_constipation }}


        //- 噁心嘔吐
        div(:class='[$style[`cc-side-effect-userRecordDetail-sec-list`], $style[`half-fill`]]')
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
            span 噁心嘔吐
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
            span.font-medium {{ formConfig.se_nausea }}


        //- 咳嗽程度
        div(:class='[$style[`cc-side-effect-userRecordDetail-sec-list`], $style[`half-fill`]]')
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
            span 咳嗽程度
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
            span.font-medium {{ formConfig.se_cough }}


        //- 喘氣程度
        div(:class='[$style[`cc-side-effect-userRecordDetail-sec-list`], $style[`half-fill`]]')
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
            span 喘氣程度
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
            span.font-medium {{ formConfig.se_pant }}


        //- 感覺疲憊
        div(:class='[$style[`cc-side-effect-userRecordDetail-sec-list`], $style[`half-fill`]]')
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
            span 感覺疲憊
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
            span.font-medium {{ formConfig.se_exhausted }}


        //- 憂鬱程度
        div(:class='[$style[`cc-side-effect-userRecordDetail-sec-list`], $style[`half-fill`]]')
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
            span 憂鬱程度
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
            span.font-medium {{ formConfig.se_melancholia }}


        //- 失眠程度
        div(:class='[$style[`cc-side-effect-userRecordDetail-sec-list`], $style[`half-fill`]]')
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
            span 失眠程度
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
            span.font-medium {{ formConfig.se_insomnia }}


        //- 手麻腳麻
        div(:class='[$style[`cc-side-effect-userRecordDetail-sec-list`], $style[`half-fill`]]')
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
            span 化療引起手麻腳麻
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
            span.font-medium {{ formConfig.se_cipn }}


        //- 放射治療皮膚炎
        div(v-if='formConfig.se_dermatitis' :class='[$style[`cc-side-effect-userRecordDetail-sec-list`], $style[`half-fill`]]')
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
            span 放射治療皮膚炎程度
              IconInfo(:size='15' :color='`#98a1a1`')
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
            span.font-medium {{ formConfig.se_dermatitis }}


        div(v-if='formConfig.se_dermatitis' :class='$style[`cc-side-effect-userRecordDetail-sec-list`]')
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-tips`]')
            div(:class='$style[`cc-side-effect-userRecordDetail-sec-tips-top`]')
              IconInfo(:size='15' :color='`#98a1a1`')
              span!= '放射治療皮膚炎程度補充說明'
            ul(:class='$style[`cc-side-effect-userRecordDetail-sec-tips-ul`]')
              li(:class='$style[`cc-side-effect-userRecordDetail-sec-tips-li`]') 第一級：輕微發紅，乾脫屑脫皮，毛髮脫落
              li(:class='$style[`cc-side-effect-userRecordDetail-sec-tips-li`]') 第二級：明顯發紅，少量濕性脫皮，輕微水腫與疼痛
              li(:class='$style[`cc-side-effect-userRecordDetail-sec-tips-li`]') 第三級：嚴重脫皮，大量濕性脫皮，明顯水腫，碰撞出血


    //- 重大事件
    section(:class='$style[`cc-side-effect-userRecordDetail-sec`]')
      div.font-medium(:class='$style[`cc-side-effect-userRecordDetail-sec-header`]') 重大事件
      div(:class='$style[`cc-side-effect-userRecordDetail-sec-container`]')
        div(:class='$style[`cc-side-effect-userRecordDetail-sec-block`]')
          header.font-medium(:class='$style[`cc-side-effect-userRecordDetail-sec-head`]') 改變的新服用藥物
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-list`]')
            div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
              span 藥物名稱
                span (中/英文皆可)
            div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
              span.font-medium {{ formConfig.supple_medicine ? formConfig.supple_medicine : `-` }}


        div(:class='$style[`cc-side-effect-userRecordDetail-sec-block`]')
          header.font-medium(:class='$style[`cc-side-effect-userRecordDetail-sec-head`]') 其他的改變治療
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-list`]')
            div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
              span 補充說明
                span (打疫苗/跌倒)
            div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
              span.font-medium {{ formConfig.supple_explanation ? formConfig.supple_explanation : `-` }}


        //- 免疫治療
        div(:class='$style[`cc-side-effect-userRecordDetail-sec-block`]')
          header.font-medium(:class='$style[`cc-side-effect-userRecordDetail-sec-head`]') 免疫治療(有接受填寫)
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-list`]')
            div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
              span 副作用產生
            div(v-if='formConfig.se_immunitytherapy.length' :class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
              nav.font-medium(v-for='(items, index) in formConfig.se_immunitytherapy' :key='index' :class='$style[`cc-side-effect-userRecordDetail-sec-chip`]') {{ items }}
            div(v-else :class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
            span.font-medium -
 

    //- CMU臨床試驗
    section(v-if='formConfig.cmu_pain' :class='[$style[`cc-side-effect-userRecordDetail-sec`], $style[`cc-side-effect-userRecordDetail-sec-cmu`]]' )
      div.font-medium(:class='$style[`cc-side-effect-userRecordDetail-sec-header`]') 臨床試驗計畫
      div(:class='$style[`cc-side-effect-userRecordDetail-sec-container`]')
        div(:class='$style[`cc-side-effect-userRecordDetail-sec-block`]')
          header.font-medium(:class='$style[`cc-side-effect-userRecordDetail-sec-head`]') 【中國醫藥附設醫院】頭頸癌記錄
          div(:class='$style[`cc-side-effect-userRecordDetail-sec-list`]')
            div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
              span 哪個部位感覺疼痛、痠痛?
            div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
              span.font-medium {{ formConfig.cmu_pain }}


          div(:class='$style[`cc-side-effect-userRecordDetail-sec-list`]')
            div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
              span 不舒服的程度?
            div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
              span.font-medium {{ formConfig.cmu_pain_level }}


          div(:class='$style[`cc-side-effect-userRecordDetail-sec-list`]')
            div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
              span 進食時會有困難嗎?
            div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
              span.font-medium {{ formConfig.cmu_eat_hard }}


          div(v-if='formConfig.cmu_eat_hard === `有`' :class='$style[`cc-side-effect-userRecordDetail-sec-list`]')
            div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
              span 進食哪個步驟覺得困難?
            div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
              span.font-medium {{ formConfig.cmu_eat_step }}


          div(v-if='formConfig.cmu_eat_hard === `有`' :class='$style[`cc-side-effect-userRecordDetail-sec-list`]')
            div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
              span 哪種狀態的食物比較困難?
            div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
              span.font-medium {{ formConfig.cmu_eat_food }}


          div(:class='$style[`cc-side-effect-userRecordDetail-sec-list`]')
            div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
              span 是否曾經嗆到?
            div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
              span.font-medium {{ formConfig.cmu_choke }}


          div(v-if='formConfig.cmu_photo_breakfast' :class='$style[`cc-side-effect-userRecordDetail-sec-gallery`]')
            div(:class='$style[`cc-side-effect-userRecordDetail-sec-list`]')
              div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
                span 早餐照片
              div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
                figure(:class='$style[`cc-side-effect-userRecordDetail-sec-photo`]')
                  img(:src='`${SERVER_STATIC_URL}media/${formConfig.cmu_photo_breakfast}`' width='100%')


            div(v-if='formConfig.cmu_photo_lunch' :class='$style[`cc-side-effect-userRecordDetail-sec-list`]')
              div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
                span 午餐照片
              div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
                figure(:class='$style[`cc-side-effect-userRecordDetail-sec-photo`]')
                  img(:src='`${SERVER_STATIC_URL}media/${formConfig.cmu_photo_lunch}`' width='100%')


            div(v-if='formConfig.cmu_photo_dinner' :class='$style[`cc-side-effect-userRecordDetail-sec-list`]')
              div(:class='$style[`cc-side-effect-userRecordDetail-sec-title`]')
                span 晚餐照片
              div(:class='$style[`cc-side-effect-userRecordDetail-sec-loader`]')
                figure(:class='$style[`cc-side-effect-userRecordDetail-sec-photo`]')
                  img(:src='`${SERVER_STATIC_URL}media/${formConfig.cmu_photo_dinner}`' width='100%')




</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
// import axios from 'axios';

import IconInfo from '../../icon/Info';
import IconLoading from '../../icon/Loading';
import IconOpenArrow from '../../icon/OpenArrow';
import IconDelete from '../../icon/Delete';
import IconTrash from '../../icon/Trash';
import Switcher from '../common/Switcher';

import {
  // getDownloadEffectRecord,
  // putUpdateSideEffectEvent,
  // putUpdateSideEffectCmuRecord,
  // deleteSideEffectRecord,
  // putUpdateSideEffectRecord,
  getLoadSideEffectRecordDetail,
} from '../../../js/restapi';

export default {
  components: {
    Switcher,
    IconInfo,
    IconDelete,
    IconTrash,
    IconLoading,
    IconOpenArrow,
  },

  props: {
    recordId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      preloading: true,
      // showLoading: false,
      isEditMode: false,
      // recordDate: null,
      alertList: [],
      // ai_report_broadcast: {},
      // ai_report_summary: {},
      // ai_report_course: [],
      formConfig: {
        se_date: '',
        se_weight: '',
        se_fever: '',
        se_cancertype: '',
        // se_cancertypeSpecial: '',
        se_now_treatment: '',
        se_qualitylife: '',
        se_painlevel: '',
        se_emotion: '',
        se_noappetite: '',
        se_upsetstomach: '',
        se_diarrhea: '',
        se_constipation: '',
        se_nausea: '',
        se_cough: '',
        se_pant: '',
        se_exhausted: '',
        se_melancholia: '',
        se_insomnia: '',
        se_dermatitis: '',
        se_cipn: '',
        se_immunitytherapy: [],
        alert_level: 0,

        change_date: '',
        change_plan: '',
        supple_date: '',
        supple_explanation: '',
        supple_medicine: '',

        cmu_pain: '',
        cmu_pain_level: '',
        cmu_eat_hard: '',
        cmu_eat_food: '',
        cmu_eat_step: '',
        cmu_choke: '',
        cmu_photo_breakfast: '',
        cmu_photo_lunch: '',
        cmu_photo_dinner: '',
      },
    };
  },

  created() {
    this.axiosLoadUserRecordDetail();
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      // changePopRecordAdviseStatus: 'global/POPRECORD_ADVISE_STATUS',
      changePopDeleteEproStatus: 'global/POPDELETE_EPRO_STATUS',
      // changePopAnalysisStatus: 'global/POPANALYSIS_STATUS',
    }),

    deleteEproRecord(recordId) {
      this.changePopDeleteEproStatus({
        active: true,
        id: recordId,
      });
    },

    axiosLoadUserRecordDetail() {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;
      getLoadSideEffectRecordDetail('', {
        aid: `${this.loginDjangoId}`,
        rid: `${this.recordId}`
      }, {
          headers: {
            'content-Type': 'application/json',
            // Authorization: `Bearer ${jwtAccess}`,
          },
        })
        .then((res) => {
          console.log('讀取副作用詳細資料 Success', res);

          // this.ai_report_broadcast = res.data.head.ai_report_broadcast;
          // this.ai_report_summary = res.data.head.ai_report_summary;
          // this.ai_report_course = res.data.head.ai_report_course;
          this.ai_report_tag = res.data.head.ai_report_tag;

          this.formConfig.se_date = res.data.head.date;
        
          this.formConfig.se_weight = res.data.a.weight;
          this.formConfig.se_fever = res.data.a.fever;
          this.formConfig.se_cancertype = res.data.head.cancertype;
          // this.formConfig.se_cancertypeSpecial = res.data.head.cancertype;
          this.formConfig.se_now_treatment = res.data.a.nowtreatment;
          this.formConfig.se_qualitylife = res.data.a.qualitylife;
          this.formConfig.se_painlevel = res.data.a.painlevel;
          this.formConfig.se_emotion = res.data.a.emotion;
          this.formConfig.se_noappetite = res.data.b.noappetite;
          this.formConfig.se_upsetstomach = res.data.b.upsetstomach;
          this.formConfig.se_diarrhea = res.data.b.diarrhea;
          this.formConfig.se_constipation = res.data.b.constipation;
          this.formConfig.se_nausea = res.data.b.nausea;
          this.formConfig.se_cough = res.data.b.cough;
          this.formConfig.se_pant = res.data.b.pant;
          this.formConfig.se_exhausted = res.data.b.exhausted;
          this.formConfig.se_melancholia = res.data.b.melancholia;
          this.formConfig.se_insomnia = res.data.b.insomnia;
          this.formConfig.se_dermatitis = res.data.b.dermatitis;
          this.formConfig.se_cipn = res.data.b.cipn;
          this.formConfig.se_immunitytherapy = JSON.parse(res.data.c);
          this.formConfig.alert_level = res.data.alert_level;

          this.formConfig.change_date = res.data.change ? res.data.change.date : '';
          this.formConfig.change_plan = res.data.change ? res.data.change.plan : '';
          this.formConfig.supple_date = res.data.supple ? res.data.supple.date : '';
          this.formConfig.supple_explanation = res.data.supple ? res.data.supple.supplement : '';
          this.formConfig.supple_medicine = res.data.supple ? res.data.supple.medicine : '';

          this.formConfig.cmu_pain = res.data.cmu ? res.data.cmu.pain : '',
          this.formConfig.cmu_pain_level = res.data.cmu ? res.data.cmu.pain_level : '',
          this.formConfig.cmu_eat_hard = res.data.cmu ? res.data.cmu.eat_hard : '',
          this.formConfig.cmu_eat_food = res.data.cmu ? res.data.cmu.eat_food : '',
          this.formConfig.cmu_eat_step = res.data.cmu ? res.data.cmu.eat_step : '',
          this.formConfig.cmu_choke = res.data.cmu ? res.data.cmu.choke : '',
          this.formConfig.cmu_photo_breakfast = res.data.cmu ? res.data.cmu.photo_breakfast : '',
          this.formConfig.cmu_photo_lunch = res.data.cmu ? res.data.cmu.photo_lunch : '',
          this.formConfig.cmu_photo_dinner = res.data.cmu ? res.data.cmu.photo_dinner : '',

          this.preloading = false;
        })
        .catch((err) => {
          console.log('讀取副作用詳細資料 Error', err);
          this.$router.replace({
            name: 'error404',
          }).catch(() => true);
        })
    },

    // checkRecordAlertLevelAndSaveAdvise() {
    //   return new Promise((resolve) => {
    //     this.changePopBoxStatus({
    //       active: true,
    //       include: 'loading',
    //     });

    //     Object.entries(this.formConfig).forEach((item) => {
    //       if (/^(?:se_emotion)$/.test(item[0]) && Number(item[1]) < 3) {
    //         this.alertList.push({
    //           name: item[0],
    //           value: item[1]
    //         });
    //       } else if (/^(?:se_painlevel)$/.test(item[0]) && Number(item[1]) > 3) {
    //         this.alertList.push({
    //           name: item[0],
    //           value: item[1]
    //         });
    //       } else if (/^(?:se_dermatitis)$/.test(item[0]) && /^(?:第二級|第三級)$/.test(item[1])) {
    //         console.log('放射治療皮膚炎程度', item[1]);
    //         this.alertList.push({
    //           name: item[0],
    //           value: item[1]
    //         });
    //       } else if (/^(?:se_immunitytherapy)$/.test(item[0]) && item[1].length) {
    //         this.alertList.push({
    //           name: item[0],
    //           value: item[1]
    //         });
    //       } else {
    //         if (/^(?:中等|嚴重)$/.test(item[1])) {
    //           this.alertList.push({
    //             name: item[0],
    //             value: item[1]
    //           });
    //         }
    //       }
    //       console.log(this.alertList);
    //     });

    //     resolve(this.alertList);
    //   })
    // },

    // recordAdviseCallBack() {
    //   this.changePopBoxStatus({
    //     active: false,
    //     include: '',
    //   });

    //   this.changePopRecordAdviseStatus({
    //     active: true,
    //     behavior: 'read',
    //     alert: this.alertList
    //   });
    // },

    // handleCheckSideEffectReport() {
    //   this.changePopBoxStatus({
    //     active: false,
    //     include: '',
    //   });

    //   this.changePopAnalysisStatus({
    //     active: true,
    //     detail: {
    //       start_date: this.formConfig.se_date,
    //       end_date: '',
    //       broadcast: this.ai_report_broadcast,
    //       summary: this.ai_report_summary,
    //       course: this.ai_report_course,
    //       tag: this.ai_report_tag,
    //     }
    //   });
    // },

    // async handleCheckSideEffectReport() {
    //   await this.checkRecordAlertLevelAndSaveAdvise();
    //   await this.recordAdviseCallBack();
    // },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      rwdType: 'global/exportRwdType',
      loginDjangoId: 'user/exportUserDjangoId',
      // authJwtToken: 'user/exportUserJwtToken',
      // loginStatus: 'user/exportLoginStatus',
      // loginProfile: 'user/exportUserProfile',
      // stateFlowBarFixed: 'global/exportFlowBarFixed',
    }),
  },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/sideeffect/effectRecordDetail.scss';
</style>
